import { OrderFields } from "../../../constants";
import { TOrderFormData } from "../../../models/orderForm";
import type { TUpdateAddressForm } from "../types";

// Used to take only those fields from order which are relevant to existing address update

const mapOrderDataToUpdateAddressData = (orderData: TOrderFormData): Partial<TUpdateAddressForm> => ({
  [OrderFields.RECEIVER_ADDRESS_ID]: orderData[OrderFields.RECEIVER_ADDRESS_ID]!,
  [OrderFields.RECEIVER_NAME]: orderData[OrderFields.RECEIVER_NAME] || undefined,
  [OrderFields.RECEIVER_PHONE_NUMBER]: orderData[OrderFields.RECEIVER_PHONE_NUMBER] || undefined,
  [OrderFields.RECEIVER_EMAIL]: orderData[OrderFields.RECEIVER_EMAIL] || undefined,
  [OrderFields.DESTINATION_COUNTRY]: orderData[OrderFields.DESTINATION_COUNTRY]!,
  [OrderFields.RECEIVER_LOCKER]: orderData[OrderFields.RECEIVER_LOCKER] || undefined,
  [OrderFields.RECEIVER_LOCKER_NAME]: orderData[OrderFields.RECEIVER_LOCKER_NAME] || undefined,
  [OrderFields.RECEIVER_STREET]: orderData[OrderFields.RECEIVER_STREET] || undefined,
  [OrderFields.RECEIVER_HOUSE_NO]: orderData[OrderFields.RECEIVER_HOUSE_NO] || undefined,
  [OrderFields.RECEIVER_FLAT_NO]: orderData[OrderFields.RECEIVER_FLAT_NO] || undefined,
  [OrderFields.RECEIVER_CITY]: orderData[OrderFields.RECEIVER_CITY] || undefined,
  [OrderFields.RECEIVER_ZIP_CODE]: orderData[OrderFields.RECEIVER_ZIP_CODE] || undefined,
});
export default mapOrderDataToUpdateAddressData;
